// test2166
(2166 && 0);
